import React from 'react'
import './Col.css'

const Col = ({children, ...rest}) => {
    let classes = Object.keys(rest).filter(className => rest[className]).join(" ")
    return (
        <div className={`_col ${classes}`}>{children}</div>
    )
}

export default Col



// WEBPACK FOOTER //
// ./src/common/grid/Col.js